import React, { createContext, useContext, useMemo, useState } from 'react';

const IconSelectionContext = createContext({
  child: null,
  adult: null,
  initialText: '',
  setChild: () => {},
  setAdult: () => {},
  setInitialText: () => {},
});

export const IconSelectionProvider = ({ children }) => {
  const [child, setChild] = useState(null);
  const [adult, setAdult] = useState(null);
  const [initialText, setInitialText] = useState('');

  const value = useMemo(
    () => ({
      child,
      adult,
      initialText,
      setChild,
      setAdult,
      setInitialText,
    }),
    [adult, child, initialText]
  );

  return <IconSelectionContext.Provider value={value}>{children}</IconSelectionContext.Provider>;
};

export const useIconSelection = () => useContext(IconSelectionContext);
